import { render } from "./QuestionRules.vue?vue&type=template&id=10d291bc&ts=true"
import script from "./QuestionRules.vue?vue&type=script&lang=ts"
export * from "./QuestionRules.vue?vue&type=script&lang=ts"

import "./QuestionRules.vue?vue&type=style&index=0&id=10d291bc&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__